module.exports = __webpack_public_path__ + "img/4.4e12e260.jpg";